import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=32febfeb&"
import script from "./Categories.vue?vue&type=script&lang=ts&"
export * from "./Categories.vue?vue&type=script&lang=ts&"
import style0 from "./Categories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Categories.vue"
export default component.exports